module.exports = __webpack_public_path__ + "img/matkailukartta-white.f2cbf9c6.svg";